import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slide"];
  static values = { interval: { type: Number, default: 3500 } };

  connect() {
    this.index = 0;
    if (this.slideTargets.length > 1) this.startAutoAdvance();
  }

  disconnect() {
    this.stopAutoAdvance();
  }

  next() {
    this.showSlide((this.index + 1) % this.slideTargets.length);
  }

  prev() {
    this.showSlide(
      (this.index - 1 + this.slideTargets.length) % this.slideTargets.length,
    );
  }

  showSlide(index) {
    this.slideTargets[this.index].classList.remove("active");
    this.index = index;
    this.slideTargets[this.index].classList.add("active");
    this.startAutoAdvance();
  }

  startAutoAdvance() {
    this.stopAutoAdvance();
    this.timer = setInterval(() => this.next(), this.intervalValue);
  }

  stopAutoAdvance() {
    if (this.timer) clearInterval(this.timer);
  }
}
